import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class ConnectionsController {
  constructor($http, $localStorage, $state, $timeout, $rootScope, $location, AuthService, SecurityService) {
    this.name = "profiles";

    $localStorage.activeStateName = "profiles";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$auth = AuthService;
    this.remain_loading_count = 1;
    this.query = "";
    this.$location = $location;
    this.$security = SecurityService;
    this.currentUser = this.$auth.getUserData();

    var _this = this;

    console.log("what is the current user");
    console.dir(this.currentUser);

    if (this.currentUser.company.circleOfConnectedJobblers.length !== 0) {
      this.$security.getConnections(this.currentUser.company.circleOfConnectedJobblers[0].id).then(function (response) {
        _this.jobblers = response.data;
        _this.remain_loading_count = 0;
      });
    } else {
      _this.remain_loading_count = 0;
    }
  }

  clickMagnify() {
    jQuery(".search-container").addClass("s-open");
    jQuery(".search-container").find('input[type="search"]').focus();
  }

  closeSearch() {
    jQuery(".search-container").removeClass("s-open");
    this.query = "";
  }

  displayPicture(pictures) {
    var _this = this;

    for (var i = 0; i < pictures.length; i++) {
      if (pictures[i].indexOf("160x160") > -1) {
        return pictures[i];
        break;
      }
    }
  }

  formatPhoneNumber(number) {
    if (number.length === 11) {
      number = number.substr(1);
      number = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    } else {
      if (number.length === 10) {
        number = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      } else {
        number = number;
      }
    }

    return number;
  }

  goToProfile(jobbler) {
    console.log("go to profile");
    console.dir(jobbler);
    var _this = this;

    _this.$timeout(function () {
      _this.$location.path("/profiles/").search({id: jobbler.id});
      //_this.$state.go('profiles');
      //_this.$rootScope.$emit("SetJobblerProfile", { jobbler : jobbler });
    }, 300);
  }
}

ConnectionsController.$inject = ["$http", "$localStorage", "$state", "$timeout", "$rootScope", "$location", "auth", "security"];

export default ConnectionsController;



// WEBPACK FOOTER //
// ./client/app/components/connections/connections.controller.js